import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Sidebar } from './components/Layout/Sidebar';
import { TopBar } from './components/Layout/TopBar';
import { Dashboard } from './pages/Dashboard';
import { HallOfFame } from './pages/HallOfFame';
import { Directory } from './pages/Directory';
import { MeetingRoom } from './pages/MeetingRoom';
import { SalesLibrary } from './pages/SalesLibrary';
import { LenderPartners } from './pages/LenderPartners';
import { MortgageTools } from './pages/MortgageTools';
import { SwiftCoins } from './pages/SwiftCoins';
import { SwiftHolidays } from './pages/SwiftHolidays';
import { EventPhotos } from './pages/EventPhotos';
import { CeoUpdates } from './pages/CeoUpdates';
export function App() {
  return <BrowserRouter data-id="element-0">
      <div style={{
      display: 'flex',
      minHeight: '100vh',
      background: '#F4F8FC',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif'
    }} data-id="element-1">
        <Sidebar data-id="element-2" />
        <div style={{
        flex: 1,
        marginLeft: 260,
        display: 'flex',
        flexDirection: 'column',
        minWidth: 0,
        overflow: 'hidden'
      }} data-id="element-3">
          <TopBar data-id="element-4" />
          <main style={{
          flex: 1,
          padding: '32px 40px',
          overflowX: 'auto',
          overflowY: 'auto'
        }} data-id="element-5">
            <Routes data-id="element-6">
              <Route path="/" element={<Dashboard data-id="element-8" />} data-id="element-7" />
              <Route path="/sales-library" element={<SalesLibrary data-id="element-10" />} data-id="element-9" />
              <Route path="/hall-of-fame" element={<HallOfFame data-id="element-12" />} data-id="element-11" />
              <Route path="/lender-partners" element={<LenderPartners data-id="element-14" />} data-id="element-13" />
              <Route path="/mortgage-tools" element={<MortgageTools data-id="element-16" />} data-id="element-15" />
              <Route path="/swift-coins" element={<SwiftCoins data-id="element-18" />} data-id="element-17" />
              <Route path="/directory" element={<Directory data-id="element-20" />} data-id="element-19" />
              <Route path="/holidays" element={<SwiftHolidays data-id="element-22" />} data-id="element-21" />
              <Route path="/event-photos" element={<EventPhotos data-id="element-24" />} data-id="element-23" />
              <Route path="/ceo-updates" element={<CeoUpdates data-id="element-26" />} data-id="element-25" />
              <Route path="/meeting-rooms" element={<MeetingRoom data-id="element-28" />} data-id="element-27" />
              {/* Fallback route */}
              <Route path="*" element={<Dashboard data-id="element-30" />} data-id="element-29" />
            </Routes>
          </main>
        </div>
      </div>
    </BrowserRouter>;
}